"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Medallia = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const loader_1 = require("./loader");
class Medallia extends web_ui_framework_1.Library {
    constructor(customerId, isUserLoggedIn) {
        super('Medallia', new loader_1.MedalliaLoader(window.MEDALLIA_URL));
        this.customerId = customerId;
        this.isUserLoggedIn = isUserLoggedIn;
        return (0, web_ui_framework_1.withLibraryLoadCheck)(this);
    }
    async load() {
        try {
            const res = await super.load();
            if (!this.customerId) {
                window.RandomNumber = Number((0, web_ui_framework_1.getRandomNumberCharacters)(9));
            }
            else {
                window.FNumber = this.customerId;
            }
            window.LoggedIn = this.isUserLoggedIn;
            window.Language = window.navigator.language;
            window.Environment = window.ENVIRONMENT;
            window.OS = window.navigator.userAgent;
            window.OS_Version = window.navigator.userAgent;
            window.Resolution = `${window.screen.width}, ${window.screen.height}`;
            return res;
        }
        catch (error) {
            const script = document.querySelector(`script[data-id="${window.MEDALLIA_URL}"]`);
            if (script) {
                script.remove();
            }
            throw error;
        }
    }
    showForm() {
        window.KAMPYLE_ONSITE_SDK.showForm(window.MEDALLIA_ALWAYS_ON_FORM_ID);
    }
}
exports.Medallia = Medallia;
//# sourceMappingURL=index.js.map